export default "__VITE_ASSET__Diq7T_hr__ 720w";